/* eslint-disable vue/return-in-computed-property */ /* eslint-disable
vue/return-in-computed-property */
<template>
  <div v-if="this.loading != true && this.insurance.length > 0 && this.reportData.length > 0">
    <v-data-iterator
      :items="data"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar dark color="secondary" class="mb-1">
          <template>
            <v-select
              v-model="sortBy"
              flat
              dense
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-sort-variant"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle background-color="rgba(0,0,0,0)" v-model="sortDesc" mandatory>
              <v-btn color="primary" height="40" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn color="primary" height="40" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:default="props">
        <v-row class="px-4">
          <v-col v-for="item in props.items" :key="item.data" cols="12" sm="6" md="4" lg="3">
            <v-card outlined class="mt-2">
              <v-card-title class="subheading font-weight-bold">{{
                item._id.insurance
              }}</v-card-title>

              <v-divider></v-divider>

              <v-list dense loading>
                <v-list-item v-for="(key, index) in filteredKeys" :key="index">
                  <v-list-item-content
                    class="font-weight-bold"
                    :class="{ 'accent--text': sortBy === key }"
                    >{{ key }} :</v-list-item-content
                  >
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-if="revenueFields.includes(key)"
                  >
                    {{
                      item[key.toLowerCase()]
                        ? `$${formatCurrency(item[key.toLowerCase()])}`
                        : 'No Data'
                    }}
                  </v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-else-if="ratioFields.includes(key)"
                  >
                    {{
                      item[key.toLowerCase()]
                        ? `${formatRatio(item[key.toLowerCase()])}`
                        : 'No Data'
                    }}
                  </v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-else-if="percentageFields.includes(key)"
                  >
                    {{
                      item[key.toLowerCase()]
                        ? `${formatNumber(item[key.toLowerCase()])} %`
                        : 'No Data'
                    }}
                  </v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    v-else
                  >
                    {{
                      item[key.toLowerCase()] ? formatNumber(item[key.toLowerCase()]) : 'No Data'
                    }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="px-7 pt-2 pb-4" align="center" justify="center">
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn dark text color="primary" v-on="on">
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">Page {{ page }} of {{ numberOfPages }}</span>
          <v-btn small fab dark color="primary" class="mr-1" @click="formerPage">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn small fab dark color="primary" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
export default {
  name: 'insComp',
  props: ['organization', 'insurance', 'startDate', 'endDate', 'reportData'],
  data() {
    return {
      search: '',
      load: true,
      sortDesc: false,
      itemsPerPageArray: [1, 2, 4, 6, 8, 12],
      page: 1,
      pagination: '',
      sortBy: 'Membership',
      loading: false,
      keys: [
        'Membership',
        'MLR',
        'MRA',
        'Revenue',
        'Expenses',
        'ER Visits',
        // "ER Per 1000",
        'ER Visits Cost',
        'Admissions',
        'Admissions Cost',
        'Outpatient Costs',
        'Outpatient Visits',
        'Total Inpatient',
        'Average Stay',
        'Inpatient days per 1000',
        'Observations',
        'Admits, ER and Observations',
        'Brand Rx Count',
        'Brand Rx Cost',
        'All Rx Count',
        'Generic Rx Count',
        'GDR',
        'Readmissions',
        'Readmissions Cost',
        // "Avg. Cost Per Adm.",
        // "Adm. Per 1000",
        // "Days Per 1000"
      ],
      data: [],
      patients: [],
      cancelSource: null,
      percentageFields: ['MLR'],
      revenueFields: [
        'Revenue',
        'Expenses',
        'ER Visits Cost',
        'Outpatient Costs',
        'Brand Rx Cost',
        'Readmissions Cost',
        'Admissions Cost',
      ],
      ratioFields: ['Admits, ER and Observations', 'Inpatient days per 1000'],
      itemsPerPage: 4,
    };
  },
  computed: {
    // Get pages and key, value pairs
    numberOfPages() {
      return Math.ceil(this.data.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter((key) => key !== 'Month');
    },
  },
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    formatCurrency(number) {
      try {
        number = Number(number);
        if (isNaN(number)) {
          throw new Error(`Input ${number} is not a number`);
        }
        return number.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      } catch (error) {
        console.error(error);
        // Return some default value or rethrow the error, depending on your use case
        return '0.00';
      }
    },

    formatNumber(num) {
      // if (num > 999) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      // }
    },
    formatRatio(num) {
      return Number(num)
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
  },
  watch: {
    async reportData() {
      const data = this.reportData;
      data.forEach((info) => {
        info._id.insurance = info._id.insurance.toUpperCase();
        info.membership = info.membership ? info.membership : 'No data';
        info.mlr = info.mlr ? info.mlr : 'No data';
        info.mra = info.mra ? info.mra : 'No data';
        info['inpatient days per 1000'] = (info['total inpatient'] / info.membership) * 1000;
        info['admits, er and observations'] =
          ((info.admissions + info['er visits'] + info.observations) / info.membership) * 1000;
        info.gdr = info.gdr ? info['generic rx count'] / info['all rx count'] : 'No data';
        info['total inpatient'] = info['total inpatient'] ? info['total inpatient'] : 'No data';
        info.revenue = info.revenue ? info.revenue : 'No data';
        info.expenses = info.expenses ? info.expenses : 'No data';
        info['er visits'] = info['er visits'] ? info['er visits'] : 'No data';
        info['er visits cost'] = info['er visits cost'] ? info['er visits cost'] : 'No data';
        info.admissions = info.admissions ? info.admissions : 'No data';
        info['admissions cost'] = info['admissions cost'] ? info['admissions cost'] : 'No data';

        info.readmissions = info.readmissions ? info.readmissions : 'No data';
        info['readmissions cost'] = info['readmissions cost']
          ? info['readmissions cost']
          : 'No data';

        info['outpatient costs'] = info['outpatient costs'] ? info['outpatient costs'] : 'No data';
        info['outpatient visits'] = info['outpatient visits']
          ? info['outpatient visits']
          : 'No data';
        info['brand rx count'] = info['brand rx count'] ? info['brand rx count'] : 'No data';
        info['brand rx cost'] = info['brand rx cost'] ? info['brand rx cost'] : 'No data';
        info['all rx count'] = info['all rx count'] ? info['all rx count'] : 'No data';
        info['generic rx count'] = info['generic rx count'] ? info['generic rx count'] : 'No data';
      });
      this.data = data;
    },
  },
};
</script>
